module.exports = __webpack_public_path__ + "static/media/hand-click.5f538421.svg";